import { IMAGES } from "@/lib/site";
import { CheckCircle2, UtensilsCrossed, Leaf } from "lucide-react";

const menu = [
  "Traditional Vegetarian Meals on Banana Leaf",
  "Neer Dosa, Akki Rotti & Ragi Dose",
  "Ottu Shavige (Homemade String Hoppers)",
  "Fresh Filter Coffee from Our Estate",
  "Kadubu, Pathrode & Malnad Curries",
  "Sweets — Kayi Holige & Payasa",
  "Farm-fresh Local Ingredients",
];

const Food = () => {
  return (
    <section
      id="food"
      data-testid="food-section"
      className="relative py-24 md:py-32 bg-[#F8FAF7]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 reveal">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-8 bg-[#D4AF37]" />
            <span className="text-[11px] tracking-[0.3em] uppercase text-[#D4AF37] font-medium">
              Authentic Malnad Food
            </span>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl text-[#1B4332] leading-[1.05] tracking-tight">
            Taste the{" "}
            <span className="italic font-light">Tradition</span>
          </h2>

          <div className="mt-6 space-y-4 text-[#1A1A1A]/75 text-base md:text-lg leading-relaxed">
            <p>
              Malnad cuisine is the soul of the Western Ghats — earthy, mildly
              spiced, and deeply rooted in the ingredients that grow right
              around us. Every meal at Navilukallu is cooked in our kitchen by
              our own family, using recipes passed down through generations.
            </p>
            <p>
              Expect fluffy <em>neer dosa</em> served on banana leaves, hot{" "}
              <em>akki rotti</em> with fresh coconut chutney, warm{" "}
              <em>ottu shavige</em>, aromatic <em>kadubu</em>, home-ground
              filter coffee from our own beans, and seasonal sweets made with
              jaggery and cardamom. Honest food — the way Malnad has always
              eaten.
            </p>
          </div>

          <ul className="mt-8 space-y-3">
            {menu.map((m, i) => (
              <li
                key={m}
                className="flex items-start gap-3 text-[#1A1A1A]/85"
                data-testid={`food-menu-item-${i}`}
              >
                <CheckCircle2
                  size={20}
                  strokeWidth={1.6}
                  className="text-[#D4AF37] shrink-0 mt-0.5"
                />
                <span className="text-base">{m}</span>
              </li>
            ))}
          </ul>

          <div className="mt-8 p-5 rounded-2xl border border-[#D4AF37]/30 bg-[#D4AF37]/5 text-sm text-[#1A1A1A]/80 flex items-start gap-3">
            <UtensilsCrossed
              size={20}
              className="text-[#D4AF37] shrink-0 mt-0.5"
              strokeWidth={1.6}
            />
            <span>
              Non-vegetarian meals can also be arranged upon prior request from
              nearby trusted restaurants.
            </span>
          </div>
        </div>

        <div className="lg:col-span-7 reveal">
          <div className="relative grid grid-cols-6 gap-3 md:gap-4">
            <div className="col-span-4 rounded-3xl overflow-hidden shadow-2xl aspect-[3/4]">
              <img
                src={IMAGES.food1}
                alt="Malnad banana-leaf thali"
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="col-span-2 flex flex-col gap-3 md:gap-4">
              <div className="rounded-3xl overflow-hidden shadow-2xl aspect-[3/4]">
                <img
                  src={IMAGES.food3}
                  alt="Ottu Shavige — homemade string hoppers on banana leaf"
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="rounded-3xl overflow-hidden shadow-2xl aspect-[3/4]">
                <img
                  src={IMAGES.food2}
                  alt="Fresh dosa with chutneys"
                  loading="lazy"
                  decoding="async"
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>
            </div>

            <div className="hidden md:flex absolute -left-6 top-1/2 -translate-y-1/2 rotate-[-8deg] items-center gap-2 px-4 py-2 rounded-full bg-[#1B4332] text-[#D4AF37] shadow-xl border border-[#D4AF37]/40">
              <Leaf size={14} strokeWidth={1.7} />
              <span className="text-[10px] tracking-[0.25em] uppercase">
                Served on Banana Leaf
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Food;
